import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { ListItem as CoreListItem } from '@vds-core/lists';
import { TypographyTokens } from '@vds-tokens/typography';
var propTypes = {
  /**
   * Option to render on dark or light surface
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * Determines the font size, line height, font family and font weight of the List item.
   */
  size: PropTypes.oneOf(['micro', 'bodySmall', 'bodyMedium', 'bodyLarge'])
};
var defaultProps = {
  surface: 'light',
  size: 'bodyLarge'
};

var _calculateLetterSpacing = function _calculateLetterSpacing(size, viewport) {
  var letterSpacing = '0px';

  if ((size === 'bodyLarge' || size === 'bodyMedium') && viewport === 'desktop') {
    letterSpacing = TypographyTokens.letterspacing.wide.value;
  }

  return letterSpacing;
};

var ListItem = function ListItem(props) {
  return /*#__PURE__*/React.createElement(CoreListItem, _extends({}, props, {
    calculateLetterSpacing: _calculateLetterSpacing
  }));
};

ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;
export default ListItem;